import { render, staticRenderFns } from "./RecommendCenter.vue?vue&type=template&id=8b855942&scoped=true&"
import script from "./RecommendCenter.vue?vue&type=script&lang=js&"
export * from "./RecommendCenter.vue?vue&type=script&lang=js&"
import style0 from "./RecommendCenter.vue?vue&type=style&index=0&id=8b855942&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b855942",
  null
  
)

export default component.exports